import { render, staticRenderFns } from "./MakeCutReturnList.vue?vue&type=template&id=35679648"
import script from "./MakeCutReturnList.vue?vue&type=script&lang=js"
export * from "./MakeCutReturnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports